import { render, staticRenderFns } from "./costaccountingForm.vue?vue&type=template&id=3080e87d&scoped=true&"
import script from "./costaccountingForm.vue?vue&type=script&lang=js&"
export * from "./costaccountingForm.vue?vue&type=script&lang=js&"
import style0 from "./costaccountingForm.vue?vue&type=style&index=0&id=3080e87d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3080e87d",
  null
  
)

export default component.exports